import globalActions from './actions/global-actions';
import listActions from './actions/list-actions';

export function updateStateFromLocation(location = document.location) {
	const params = new URL(location).searchParams;
	const stand = params.get('stand') || null;
	globalActions.selectStand(stand);
	listActions.showDetails(stand);
}

export function updateUrl(standId) {
	const url = standId
		? `?stand=${encodeURIComponent(standId)}#${encodeURIComponent(standId)}`
		: '?list';
	console.log('update url', window.location.search);

	if (window.parent && window.parent !== window) {
		if (url === window.parent.location.search) {
			return;
		}

		try {
			window.parent.history.pushState({}, null, url);
		} catch (e) {
			// ignore
		}
	} else {
		if (url === window.location.search) {
			return;
		}

		window.history.pushState({}, null, url);
	}
}
